import React, { useEffect, useState } from 'react';
import { ChakraProvider, theme } from '@chakra-ui/react';
import PurchaseGallery from './PurchaseGallery';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { getPurchasedCollection } from '../apis/Purchase';
import { debounce } from 'lodash-es';

const Purchased = props => {
  // const [eventsPurchase, setEventsPurchase] = useState([]);
  const [eventsData, setEventData] = useState([]);
  const userProfile = useStoreState(state => state.userProfile);
  const [errorMessage, setErrorMessage] = useState('No Data Found !');
  const isUserLogged = useStoreState(state => state.isUserLogged);
  const purchaseCollection = useStoreState(state => state.purchaseCollection);
  const { id } = props.match.params;
  const [limitError, setLimitError] = useState(false);
  var counter = 0;
  const handleUserProfile = useStoreActions(store => store.handleUserProfile);
  const handlePurchaseCollection = useStoreActions(store => store.handlePurchaseCollection);

  function fetchEventPurchase(counter=0) {
    getPurchasedCollection(
      userProfile.api_key,
      id,
      userProfile.user_profile_id,
      counter
    ).then(response => {
      if (!response.error) {
        let transData = [];
        if (Boolean(response.collection_object?.length)) {
          response.collection_object.map((i, index) => {
            transData.push({ ...i, isSelected: false, isUnSelected: true });
            return null;
          });
        } 
        handlePurchaseCollection(transData)
        setEventData(response.data);
        setErrorMessage(null);
      } else {
        (counter > 0) ? setLimitError(true) : setErrorMessage(response.message);
      }
    });
  }
 
  useEffect(() => (isUserLogged ? fetchEventPurchase() : null), []);

  function updateCounter(){
    if(isUserLogged){
      fetchEventPurchase(counter+1)
      counter = counter+1
    }    
}
const debounceCollectionCall = debounce(updateCounter, 300);

  return (
    <ChakraProvider theme={theme}>
      <PurchaseGallery
        error={errorMessage}
        collection={purchaseCollection}
        fetchMore={debounceCollectionCall}
        Status={'Purchased'}
        limitError={limitError}
      />
    </ChakraProvider>
  );
};
export default Purchased;
